<template>
  <div class="Flagmarker" :class="{'flagmarkerAdmin':storeInfo.type===99}">
    <div v-if="storeInfo.type===3&&!isGroup">
    <template v-for="(item,index) in travel" >
        <div class="travel"  :key="index" v-if="showCommentBtn(item.type)&&$GFUN.isInArray([7,8,9],orderDetail.status)&&orderDetail.status!=99||showCommentBtn(item.type)&&orderDetail.hotel_flag&&orderDetail.hotel_flag!=0" >
        <i></i>
        <el-tooltip class="item" effect="dark" content="编辑标记信息,仅自己可见" placement="bottom">
            <i  class="el-icon-s-flag" :class="flagson(item.type)" @click="getOrderFlag(orderDetail,item.type)"></i>  
        </el-tooltip>
        </div>
    </template>
    </div>
    <div v-if="storeInfo.type===2&&!isGroup">
    <template v-for="(item,index) in travel" >
        <div class="travel"  :key="index" v-if="showCommentBtn(item.type)" >
        <i></i>
        <el-tooltip class="item" effect="dark" content="编辑标记信息,仅自己可见" placement="bottom">
            <i  class="el-icon-s-flag" :class="flagson(item.type)" @click="getOrderFlag(orderDetail,item.type)"></i>  
        </el-tooltip>
        </div>
    </template>
    </div>
    <div v-if="storeInfo.type===99" class="admin">
        <div class="travel" v-for="(item,index) in travel" :key="index">
          <i class="ks">{{item.name}}</i>
          <el-tooltip class="item" effect="dark" content="编辑标记信息,仅自己可见" placement="bottom">
              <i  class="el-icon-s-flag" :class="flagson(item.type)" @click="getOrderFlag(orderDetail,item.type)"></i>
          </el-tooltip>
        </div>
        
    </div>
    <!--标记弹出框-->
    <el-dialog  :visible.sync="showConfirmPanel" width="600px" center id="loadConfirm">
      <HotelOrderIFlag :flagtiem='flagtiem' :flagtype='flagtype' @getOrderList="$emit('getorderDetail')" @firmPanel="showConfirmPanel=!showConfirmPanel" v-if="showConfirmPanel"/>
      <div slot="footer"></div>
    </el-dialog>
  </div>
</template>

<script>
import HotelOrderIFlag from '../../../OrderLists/HotelOrderIFlag'
import { mapState, mapGetters, mapActions,mapMutations } from 'vuex'
export default {
  name: 'OrderFlagMarker',
  components: {
    HotelOrderIFlag,
  },
  props: {
    orderDetail: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
        travel:[
            {name:'管',type:99},
            {name:'旅',type:2},
            {name:'酒',type:3},
        ],
        breakfastArr:[
            {name:'delete',id:0},
            {name:'red',id:1},
            {name:'Orange',id:2},
            {name:'green',id:3},
            {name:'greys',id:4},
            {name:'purple',id:5}
        ],
        flagtype:'',
        flagtiem:[],
        showConfirmPanel:false,
    };
  },
  computed: {
         ...mapGetters(['storeInfo','isGroup']),
  },
  watch: {},
  created() {},
  mounted() {},
  methods: {
    /*显示标注按钮*/
    showCommentBtn (e) {
      let t = this.storeInfo.type;
      if(e==t) return true
    },
    flagson(n) {
      let {orderDetail,breakfastArr}=this;
        switch (n) {
          case 99: return breakfastArr[orderDetail.admin_flag||0].name;
          case 2:  return breakfastArr[orderDetail.travel_flag||0].name;
          case 3:  return breakfastArr[orderDetail.hotel_flag||0].name;
        }
    },
    /*开始标记*/
    getOrderFlag(e,type){
        this.flagtype=type;
        this.flagtiem=e;
        this.showConfirmPanel=true;
    },
  }
};
</script>

<style lang="scss" scoped>
.Flagmarker{
    margin-top: 16px;
    margin-left: 10px;
}
.admin{
  display: flex;
}
.ks{
    font-style: normal;
    color: #666;
    border: 1px #666 solid;
    font-size: 12px;
    border-radius: 50px;
    padding: 2px 3px;
    margin-right: 4px;
}
.el-icon-s-flag{
  margin-right: 10px;
}
.flagmarkerAdmin{
  margin-top: 10px;
}
</style>
